import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  createProject,
  updateProject,
  reqConsultation,
  feedBackOnContractor,
  suggestMore,
  followUpRequest,
  clickOnContractor
} from "api/mutations/project";
import { getProject, getProjects } from "api/queries/project";

export function useGetProjects(params) {
  return useQuery(["projects"], () => getProjects(params));
}

export function useGetProject(params) {
  return useQuery(["project", params], () => getProject(params), {
    enabled: Boolean(params.enabled),
  });
}

export const useCreateProject = () => {
  return useMutation((body) => createProject(body));
};

export const useUpdateProject = () => {
  const queryClient = useQueryClient();
  return useMutation((body) => updateProject(body), {
    onSuccess: () => {
      queryClient.refetchQueries(["projects"]);
    },
  });
};

export const useConsultationRequest = () => {
  const queryClient = useQueryClient();
  return useMutation((id) => reqConsultation(id), {
    onSuccess: () => {
      queryClient.refetchQueries(["projects"]);
    },
  });
};

export const useFeedBackOnContractor = () => {
  const queryClient = useQueryClient();
  return useMutation((body) => feedBackOnContractor(body), {
    onSuccess: () => {
      queryClient.refetchQueries(["projects"]);
    },
  });
};

export const useSuggestMoreContractors = () => {
  const queryClient = useQueryClient();
  return useMutation((id, body) => suggestMore(id, body), {
    onSuccess: () => {
      queryClient.refetchQueries(["projects"]);
    },
  });
};

export const useFollowUpRequest = () => {
  const queryClient = useQueryClient();
  return useMutation((body) => followUpRequest(body), {
    onSuccess: () => {
      queryClient.refetchQueries(["projects"]);
    },
  })
};

export const useClickOnContractor = () => {
  return useMutation((body) => clickOnContractor(body));
};